import { i18n } from '@/utils/i18n';

export const columns = {
    id: {
        show: true,
        title: "№",
        sortable: true,
        column: 'id'
    },
    code: {
        show: true,
        title: i18n.t('message.code_id'),
        sortable: true,
        column: 'id'
    },
    branch: {
        show: true,
        title: i18n.t('message.branch'),
        sortable: true,
        column: 'class'
    },
    owner_branch: {
        show: true,
        title: i18n.t('message.owner_branch'),
        sortable: true,
        column: 'owner_branch'
    },
    created_at: {
        show: true,
        title: i18n.t('message.date'),
        sortable: true,
        column: 'created_at'
    },
    updated_at: {
        show: false,
        title: i18n.t('message.update_date'),
        sortable: true,
        column: 'updated_at'
    },
    settings: {
        show: true,
        title: i18n.t('message.settings'),
        sortable: false,
        column: 'settings'
    }
};
